document.addEventListener('DOMContentLoaded', () => {
  const POPUPS = document.querySelectorAll('.morning-popup');
  if (POPUPS.length > 0) {
    POPUPS.forEach(POPUP => {
      const morningPopup = new MorningPopup(POPUP)
      morningPopup.init()
    })
  }
})

class MorningPopup {
  constructor (POPUP) {
    this.popup = POPUP
    this.popupId = POPUP.dataset.popupId
    this.popupDelay = POPUP.dataset.initDelay ? parseInt(POPUP.dataset.initDelay) : 0
    this.openButton = POPUP.previousElementSibling
  }

  init () {
    this.openButton.addEventListener('click', () => this.show())

    if (this.popupDelay > 0 && sessionStorage.getItem(this.popupId) === null) {
      setTimeout(() => this.show(), this.popupDelay * 1000)
    }
  }

  show () {
    openModal(this.popup)
    sessionStorage.setItem(this.popupId, 'true')
  }
}
